const card = {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async queryPrintFieldListByCategory({ rootState, commit, dispatch }, params) {
      const data = await rootState.http("/printTemplate/findValidTemplateByCategory", params);
      return data;
    },
    async getPrintStoreLogo({ rootState, commit }, params = {}) {
      const data = await rootState.http("/printTemplate/getPrintStoreLogo", params);
      return data;
    }
  }
};

export default card;



// WEBPACK FOOTER //
// ./src/store/modules/setting.js